module.exports = __webpack_public_path__ + "img/hyperx-pulsefire-haste-preview.0e736c2f.png";